"use strict";
// @ts-ignore
try {
    self['workbox:strategies:7.4.0'] && _();
}
catch (e) { }
